import InternationalizationService from "./services/InternationalizationService.js";
import numbro from "numbro";

const service = InternationalizationService.instance();

service.allLocales().forEach((locale) => locale.registerIn(numbro));

const numbroWrapper = numbro;

export default numbroWrapper;

function configureNumbroLanguage(language) {
	language.formats.millionWithTwoDecimals = {
		output: "currency",
		characteristic: 1,
		optionalCharacteristic: false,
		average: true,
		forceAverage: "million",
		mantissa: 2,
		optionalMantissa: true,
		trimMantissa: false,
		thousandSeparated: true,
		spaceSeparated: language.languageTag !== "en-GB",
		spaceSeparatedCurrency: language.languageTag !== "en-GB",
	};

	language.formats.thousandNoDecimals = {
		output: "currency",
		characteristic: 1,
		average: true,
		forceAverage: "thousand",
		thousandSeparated: true,
		spaceSeparated: language.languageTag !== "en-GB",
		spaceSeparatedCurrency: language.languageTag !== "en-GB",
	};

	language.formats.fullNoDecimals = {
		mantissa: 0,
		thousandSeparated: true,
		spaceSeparated: language.languageTag !== "en-GB",
	};

	language.formats.fullWithNoDecimalsNorCurrency = {
		mantissa: 0,
		thousandSeparated: true,
		spaceSeparated: language.languageTag !== "en-GB",
	};
}

function configureNumbroLanguages() {
	Object.values(numbro.languages()).forEach((language) =>
		configureNumbroLanguage(language),
	);
}

configureNumbroLanguages();
